module.exports = __webpack_public_path__ + "img/IMG_6772.be8ad22b.jpg";